import { Pencil, Trash2, QrCode, Ticket } from 'lucide-react';
import { CompanyQrcode } from '../../types/qrcode';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableHeader,
  TableRow,
  Button,
  Badge,
  EmptyState,
} from '../ui';

interface QrcodeListProps {
  qrcodes: CompanyQrcode[];
  onEdit: (qrcode: CompanyQrcode) => void;
  onDelete: (qrcode: CompanyQrcode) => void;
  onManageCoupons: (qrcode: CompanyQrcode) => void;
  isLoading?: boolean;
}

function QrcodeList({ qrcodes, onEdit, onDelete, onManageCoupons, isLoading }: QrcodeListProps) {
  if (isLoading) {
    return (
      <div className="flex justify-center py-8">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary-600"></div>
      </div>
    );
  }

  if (qrcodes.length === 0) {
    return (
      <EmptyState
        icon={<QrCode className="h-12 w-12" />}
        title="Nenhum QR Code encontrado"
        description="Crie seu primeiro QR Code para começar"
      />
    );
  }

  return (
    <TableContainer>
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead className="whitespace-nowrap">Empresa</TableHead>
            <TableHead className="whitespace-nowrap">Promoção</TableHead>
            <TableHead className="whitespace-nowrap">Data</TableHead>
            <TableHead className="whitespace-nowrap">Qtd. Cupons</TableHead>
            <TableHead className="whitespace-nowrap">Status</TableHead>
            <TableHead className="relative whitespace-nowrap">
              <span className="sr-only">Ações</span>
            </TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {qrcodes.map(qrcode => (
            <TableRow key={qrcode.id}>
              <TableCell>{qrcode.company_name}</TableCell>
              <TableCell>{qrcode.promotion_name}</TableCell>
              <TableCell className="whitespace-nowrap">
                {new Date(qrcode.qr_date).toLocaleDateString()}
              </TableCell>
              <TableCell>{qrcode.coupon_quantity}</TableCell>
              <TableCell>
                <Badge variant={qrcode.send ? 'success' : 'warning'}>
                  {qrcode.send ? 'Enviado' : 'Pendente'}
                </Badge>
              </TableCell>
              <TableCell className="text-right whitespace-nowrap">
                <div className="flex justify-end space-x-2">
                  <Button variant="ghost" onClick={() => onManageCoupons(qrcode)} title="Cupons">
                    <Ticket className="h-4 w-4 text-primary-600" />
                  </Button>
                  <Button variant="ghost" onClick={() => onEdit(qrcode)} title="Editar">
                    <Pencil className="h-4 w-4" />
                  </Button>
                  <Button variant="ghost" onClick={() => onDelete(qrcode)} title="Excluir">
                    <Trash2 className="h-4 w-4 text-red-600" />
                  </Button>
                </div>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default QrcodeList;
